var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',[_vm._v(_vm._s(_vm.content)+" "),_c('el-button',{attrs:{"type":"success","size":"mini","circle":"","plain":"","icon":"el-icon-copy-document"},on:{"click":_vm.handleCopy}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }